<template>
  <v-card class="modern-chart-card pa-4">
    <LineChartGenerator
      :chart-options="options"
      :chart-data="data"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </v-card>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 388,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
    },
  },
  data() {
    const vm = this;
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        borderColor: "#5928e5",
        tension: 0.4,
        elements: {
          point: {
            pointStyle: "circle",
            hoverBorderWidth: 3,
            hitRadius: 20,
            radius: 0,
            hoverRadius: 10,
            backgroundColor: "white",
          },
        },
        scales: {
          y: {
            ticks: {
              display: false,
            },
            grid: {
              drawBorder: false,
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            displayColors: false,
            callbacks: {
              title: function () {},
              label: function (items) {
                return vm.type === "REVENUE"
                  ? "$ " + items.dataset.data[items.dataIndex]
                  : "" + items.dataset.data[items.dataIndex];
              },
            },
            xAlign: "center",
            yAlign: "bottom",
            backgroundColor: "#f8f8f800",
            bodyColor: "#5928e5",
            bodyFont: {
              size: 17,
              weight: "bolder",
            },
          },
        },
      },
    };
  },
};
</script>
<style scoped>
.modern-chart-card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 20px 0 rgba(31, 38, 135, 0.05) !important;
}
</style>
